import { useState } from 'react';
import { Link } from 'react-router-dom';
import { User, LogOut } from 'lucide-react';
import toast from 'react-hot-toast';

interface UserMenuProps {
  user: any;
  signOut: () => Promise<void>;
}

/** Desktop user avatar dropdown with auth actions */
export function UserMenu({ user, signOut }: UserMenuProps) {
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  if (!user) {
    return (
      <div className="flex items-center space-x-3">
        <Link
          to="/auth"
          className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 hover:text-jme-purple transition-all duration-300 link-hover-effect"
        >
          Sign In
        </Link>
        <Link
          to="/programs"
          className="inline-flex items-center px-4 py-2 text-sm font-medium rounded-lg text-white bg-gradient-to-r from-jme-purple to-purple-600 hover:from-purple-600 hover:to-jme-purple transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg btn-hover-effect"
        >
          Get Started
        </Link>
      </div>
    );
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsProfileOpen(!isProfileOpen)}
        className="flex items-center space-x-2 px-4 py-2 rounded-lg bg-gradient-to-r from-jme-purple/10 to-purple-100 hover:from-jme-purple/20 hover:to-purple-200 text-gray-900 transition-all duration-300 transform hover:scale-105"
      >
        <User className="w-5 h-5" />
        <span className="text-sm font-medium">{user.user_metadata.full_name || 'Account'}</span>
      </button>
      {isProfileOpen && (
        <div className="absolute right-0 mt-2 w-56 bg-white/95 backdrop-blur-sm rounded-lg shadow-lg py-2 z-50 border border-purple-100 animate-scaleIn">
          <Link
            to="/dashboard"
            className="flex items-center px-4 py-2 text-gray-700 hover:bg-gradient-to-r hover:from-jme-purple/10 hover:to-purple-100 transition-colors duration-200 hover:translate-x-1"
            onClick={() => setIsProfileOpen(false)}
          >
            <User className="w-4 h-4 mr-2" />
            Dashboard
          </Link>
          <button
            onClick={async () => {
              await signOut();
              setIsProfileOpen(false);
              toast.success('Signed out successfully');
            }}
            className="w-full text-left px-4 py-2 text-red-600 hover:bg-red-50 flex items-center hover:translate-x-1 transition-transform duration-200"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
}
